// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common-layout_container__X3Jnv {\n  padding: 30px 20px;\n}\n\n.common-layout_top_content__1VFAO {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.common-layout_container_without_padding__1u4Qx .common-layout_page_content__10EkU {\n  display: flex;\n  min-height: calc(100vh - 54px);\n}\n.common-layout_container_without_padding__1u4Qx .common-layout_right_section_content__1qFdr {\n  width: 100%;\n  padding: 30px 20px;\n}", ""]);
// Exports
exports.locals = {
	"container": "common-layout_container__X3Jnv",
	"top_content": "common-layout_top_content__1VFAO",
	"container_without_padding": "common-layout_container_without_padding__1u4Qx",
	"page_content": "common-layout_page_content__10EkU",
	"right_section_content": "common-layout_right_section_content__1qFdr"
};
module.exports = exports;
